import { ExpertOptionCondition } from "./expertOptionCondition"
import { ExpertOptionField } from "./expertOptionField"

export class ExpertFieldOptions {
    /**
     * 
     * @param {ExpertOptionCondition} expertOptionCondition 
     * @param {[ExpertFieldOptions | ExpertOptionField]} expertOptionFields 
     */
    constructor(expertOptionCondition, expertOptionFields) {
        if (!(expertOptionCondition instanceof ExpertOptionCondition)) {
            throw new Error(`expertOptionCondition is not an instance of ExpertOptionCondition`)
        }

        if (!Array.isArray(expertOptionFields)) {
            throw new Error(`expertOptionFields is not an array`)
        }

        if (!this.checkIfOptionFieldsAreValid(expertOptionFields)) {
            throw new Error(`Contents of expertOptionFields is not valid. It has to be either an ExpertOptionField or ExpertFieldOptions`)
        }

        this.condition = expertOptionCondition
        this.fields = expertOptionFields
    }

    checkIfOptionFieldsAreValid(options) {
        for (let option of options) {
            if (option instanceof ExpertFieldOptions) {
                const optionResult = this.checkIfOptionFieldsAreValid(option.fields)
                if (optionResult) {
                    continue
                } else {
                    return false
                }
            } else if (option instanceof ExpertOptionField) {
                if (option.isValid) {
                    continue
                } else {
                    return false
                }
            } else {
                return false
            }
        }

        return true
    }

    static EXPERT_CREATION_OPTIONS = Object.freeze(new ExpertFieldOptions(
        ExpertOptionCondition.And,
        [
            ExpertOptionField.Title,
            ExpertOptionField.FirstName,
            ExpertOptionField.LastName,
            ExpertOptionField.City,
            ExpertOptionField.Country,
            ExpertOptionField.Timezone,
            ExpertOptionField.Industry,
            ExpertOptionField.Language,
            ExpertOptionField.WorkExperience,
            ExpertOptionField.Email
        ]
    ))

    static EXPERT_ADD_TO_LIST_OPTIONS = Object.freeze(new ExpertFieldOptions(
        ExpertOptionCondition.And,
        [
            ExpertOptionField.FirstName,
            new ExpertFieldOptions(
                ExpertOptionCondition.Or,
                [
                    ExpertOptionField.Email,
                    ExpertOptionField.PhoneNumber
                ]
            )]
    ))

    static EXPERT_ADD_TO_PROJECT_OPTIONS = Object.freeze(new ExpertFieldOptions(
        ExpertOptionCondition.And,
        [
            ExpertOptionField.Title,
            ExpertOptionField.FirstName,
            ExpertOptionField.LastName,
            ExpertOptionField.City,
            ExpertOptionField.Country,
            ExpertOptionField.Timezone,
            ExpertOptionField.Industry,
            ExpertOptionField.Language,
            ExpertOptionField.WorkExperience,
            ExpertOptionField.IndustryExperience,
            ExpertOptionField.Email
        ]
    ))
}